export default "__VITE_ASSET__BdjJBxLi__"